import { render, staticRenderFns } from "./ModalCourrierActes.vue?vue&type=template&id=3abfbc9d&"
import script from "./ModalCourrierActes.vue?vue&type=script&lang=js&"
export * from "./ModalCourrierActes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports